import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavBarService {
  isNavDrawerOpen = signal<boolean>(
    localStorage.getItem('isNavbarOpen') === 'true'
  );
  isNavDrawerOpenMobile = signal<boolean>(false);
  constructor() {
    effect(() => {
      localStorage.setItem('isNavbarOpen', '' + this.isNavDrawerOpen());
    });
  }
}
